module.exports = __webpack_public_path__ + "img/logo-freebsd-devil.08a0c13b.svg";